export default "__VITE_ASSET__d2e036d4__"